import React from 'react';

const CompassSVG = ({ title, ...props }) => (
  <svg aria-label={title} viewBox="0 0 24 24" {...props}>
    {title ? <title id="title">{title}</title> : null}
    <path d="M12 4L8 9h8l-4-5z" />
    <path d="M12 20l4-5H8l4 5z" fill="#999999" />
  </svg>
);

export default CompassSVG;
